'use client';

import { Accordion, AccordionGroup } from 'ui';
import { DeliveryTable } from '@/modules/delivery/components/deliveryTable/DeliveryTable';
import { ContactCards } from '@/shared/components/contactCards';
import { useTranslation } from '@/i18n/client';
import { ShippingMethod } from '@/modules/checkout/api';
import { formatPrice } from 'utils';

import styles from './DeliveryPage.module.scss';
import { useBasket } from '@/shared/context/basket-context';
import { getDeliveryDescription } from './utils';

export const DeliveryPage = ({ shippingMethods }: { shippingMethods: ShippingMethod[] }) => {
	const { t } = useTranslation(['delivery', 'common', 'faq']);
	const { freeShippingPrice } = useBasket();

	return (
		<div className={styles.Delivery}>
			<div className={styles['Delivery--wrapper']}>
				<div className="container">
					<div className={styles['Delivery__overflow-wrapper']}>
						<div className={styles['Delivery__title']}>
							<h1 className={styles['Delivery__title--title']}> {t('breadcrumbs.delivery')}</h1>
							<p className={styles['Delivery__title--description']}>
								{t('deliveryOptions.description')}
							</p>
						</div>
						<DeliveryTable
							rows={shippingMethods.map((method) => ({
								title: method.name,
								time:
									method.shippingDays === 0
										? t(`deliveryOptions.immediate`)
										: t('common.inDays', { days: method.shippingDays }),
								cost: formatPrice(method.price.amount, method.locale, method.price.currency),
								imageUrl: method.image,
								details: t(getDeliveryDescription(method.shippingCode))
							}))}
						/>
						<div className={styles['Delivery__additional-info-list']}>
							<ul>
								<li>{t('deliveryOptions.orderInformation')}</li>
								<li>{t('deliveryOptions.deliveryInformation')}</li>
								<li>{t('deliveryOptions.shipmentInformation')}</li>
							</ul>
						</div>
						<div className={styles['Delivery__questions-wrapper']}>
							<h4 className={styles['Delivery__question-title']}>{t('faq:faq.title')}</h4>
							<div className={styles['Delivery__questions-list']}>
								<AccordionGroup>
									<Accordion heading={t('faq:faq.collectPaymentQuestion')}>
										<div className={styles['Delivery__questions-question']}>
											<p>{t('faq:faq.collectPaymentAnswer')}</p>
										</div>
									</Accordion>
									<Accordion heading={t('faq:faq.orderCompletionTimeQuestion')}>
										<div className={styles['Delivery__questions-question']}>
											<p>{t('faq:faq.orderCompletionTimeAnswer')}</p>
										</div>
									</Accordion>
									<Accordion heading={t('faq:faq.shipmentInfoChangeQuestion')}>
										<div className={styles['Delivery__questions-question']}>
											<p>{t('faq:faq.shipmentInfoChangeAnswer')}</p>
										</div>
									</Accordion>
								</AccordionGroup>
							</div>
						</div>
						<div className={styles['Delivery__contact-wrapper']}>
							<h3>{t('common:common.cannotFindAnswer')}</h3>
							<h4>{t('delivery.contact')}</h4>
							<ContactCards showTitle={false} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
